module.exports = __webpack_public_path__ + "img/welcomeSprite3.8010ba32.png";